/**
 * SF-4847: one small icon per module key, shared by the wizard's Modules step and the plan's
 * Modules card. A key not listed here (a module chat-service names that this page does not know
 * yet) gets the generic icon, so a new module never breaks the page.
 */
import {
  AppstoreOutlined,
  AuditOutlined,
  BookOutlined,
  CarryOutOutlined,
  CheckSquareOutlined,
  CustomerServiceOutlined,
  DashboardOutlined,
  EnvironmentOutlined,
  FormOutlined,
  MessageOutlined,
  RobotOutlined,
  StarOutlined,
  TeamOutlined,
} from '@ant-design/icons';

const ICONS: Record<string, React.ComponentType> = {
  survey_module: FormOutlined,
  customer_audit_module: AuditOutlined,
  help_desk_module: CustomerServiceOutlined,
  ratings_module: StarOutlined,
  client_connect_module: MessageOutlined,
  action_plan_module: CarryOutOutlined,
  task_module: CheckSquareOutlined,
  knowledgebase_module: BookOutlined,
  eva_module: RobotOutlined,
  dashboard_module: DashboardOutlined,
  location_module: EnvironmentOutlined,
  users_module: TeamOutlined,
};

export const ModuleIcon: React.FC<{ moduleKey: string }> = ({ moduleKey }) => {
  const Icon = ICONS[moduleKey] ?? AppstoreOutlined;
  return (
    // Decorative: the module's name is next to it.
    <span aria-hidden data-testid="module-icon" data-icon={ICONS[moduleKey] ? moduleKey : 'generic'}>
      <Icon />
    </span>
  );
};
